import type { RigListItem } from '@chukua/common';
import { Button } from 'antd';

export type UnitRowAction = 'couple-truck' | 'couple-trailer';

/**
 * What a row offers: a truck that can tow takes a trailer, a parked trailer goes onto a truck. Swapping or dropping a coupled
 * trailer is rare, so it lives on the unit's own page rather than on every row.
 */
export function UnitRowActions({ rig, onAction }: { rig: RigListItem; onAction: (action: UnitRowAction, rig: RigListItem) => void }) {
  const act = (action: UnitRowAction) => (event: React.MouseEvent) => {
    event.stopPropagation();
    onAction(action, rig);
  };
  if (rig.kind === 'coupled') return null;
  if (rig.kind === 'trailer_only') {
    if (rig.trailer && !rig.trailer.isActive) return null;
    return (
      <Button type="link" size="small" onClick={act('couple-trailer')}>
        Couple to a truck
      </Button>
    );
  }
  if (rig.truck?.coupling === 'none') return null;
  return (
    <Button type="link" size="small" onClick={act('couple-truck')}>
      Couple a trailer
    </Button>
  );
}
